export enum EaveSide {
  Front = 'front',
  Back = 'back',
  Right = 'right',
  Left = 'left',
}
